import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrainingItemGroupSearchResult } from '../models/training-item-group-search-result';
import { PanelList } from '../../shared/models/panel-list';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { FilterMenu } from '../../shared/models/filter-menu';
import { SortMenu } from '../../shared/models/sort-menu';
import { CommonService } from '../../shared/services/common.service';

@Component({
  selector: 'app-training-item-group-panel-list',
  templateUrl: './training-item-group-panel-list.component.html',
  styleUrls: ['./training-item-group-panel-list.component.scss']
})
export class TrainingItemGroupPanelListComponent implements OnInit{
  @Input() trainingItemGroupResult?: TrainingItemGroupSearchResult[];
  @Output() selectedItems = new EventEmitter();
  noData: boolean = false;

  constructor(private eqmsScopeManagementService: EqmsScopeManagementService,
    private commonService: CommonService){

  }
  ngOnInit(): void {
    this.setUp();
  }

  ngOnChanges():void{
    this.setUp();
  }

  setUp(){
    this.trainingItemGroupsPanelListData.lists = this.trainingItemGroupResult;
    this.trainingItemGroupsPanelListData.filters = this.getFiltersForTrainingItemGroupPanelList();
    this.trainingItemGroupsPanelListData.sort = this.getSortFieldsForForTrainingItemGroupPanelList();
    this.trainingItemGroupsPanelListData = { ...this.trainingItemGroupsPanelListData }
    this.noData = this.commonService.IsListEmpty(this.trainingItemGroupResult);
    this.getTrainingItemGroupDisplayName();
    this.updateeQMSScopeData();
  }

  getTrainingItemGroupDisplayName(){
    this.trainingItemGroupsPanelListData.lists.forEach((trainingItemGroup: { displayName: string; number: string; name: string; })=>{
      trainingItemGroup.displayName = trainingItemGroup.number + " " + trainingItemGroup.name;
    })
  }

  trainingItemGroupsPanelListData: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableSelection: true,
    enableToggling: false,
  };
  getSelectedItems(selectedItemsData: TrainingItemGroupSearchResult[]) {
    this.selectedItems.emit(selectedItemsData);
  }

  updateeQMSScopeData(){

    this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((eQMSScopes)=>{
      this.trainingItemGroupsPanelListData.lists.forEach((trainingItemGroup: {
        eQMSScopeDisplayNames: string[]; eQMSScopes: number[]; 
  })=>{
        trainingItemGroup.eQMSScopeDisplayNames = [];
        trainingItemGroup.eQMSScopes.forEach((eQMSScopeData : number)=>{
          let eQMSScope = eQMSScopes.filter((e: { eQMSScopeId: number; }) => {return e.eQMSScopeId === eQMSScopeData});
          if(trainingItemGroup.eQMSScopeDisplayNames === undefined 
            || trainingItemGroup.eQMSScopeDisplayNames === null) 
            trainingItemGroup.eQMSScopeDisplayNames = [];
            trainingItemGroup.eQMSScopeDisplayNames?.push(eQMSScope[0].eQMSScopeName);
        })
      })
      this.trainingItemGroupsPanelListData.filters = this.getFiltersForTrainingItemGroupPanelList();
      this.trainingItemGroupsPanelListData.sort =  this.getSortFieldsForForTrainingItemGroupPanelList();
      this.trainingItemGroupsPanelListData = { ...this.trainingItemGroupsPanelListData }
    });
  }

  getFiltersForTrainingItemGroupPanelList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push({
      filterDisplayName: 'eQMS Scope',
      filterFieldName: 'eQMSScopeDisplayNames',
    });
    return filters;
  }

  getSortFieldsForForTrainingItemGroupPanelList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'eQMS Scope',
        sortFieldName: 'eQMSScopeDisplayNames',
      },
      {
        sortFieldDisplayName: 'Name',
        sortFieldName: 'displayName',
      });
      return sortMenu;
    }

    clearSelection(){
      this.trainingItemGroupsPanelListData.clearSelection = true;
        this.trainingItemGroupsPanelListData = { ...this.trainingItemGroupsPanelListData };
    }
}
